import '../../App.css';

function HeaderHero() {
    return (
        <header className="header">
            <div className="header-container">
                <div className="circle-headshot-container">
                    <div className="circle-headshot"/>
                </div>
                <div className="header-text-box">
                    <h1>Allison Nocita, BSN, RN, MT-BC</h1>
                    <h3>Board Certified Music Therapist</h3>
                    <h3>Registered Nurse</h3>
                    <h5 className="header-subtitle">Servicing San Diego County & Remote</h5>
                    <h5>Inpatient | Home Care | Group Facilities</h5>
                </div>
            </div>
        </header>
    )
}

export default HeaderHero;